<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="设备类型：" prop="device_type">
                <el-select clearable v-model="evice_type" placeholder="请选择" disabled style="width: 150px">
                    <el-option v-for="item in enuObj('device_type')" :key="'device_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <el-input v-model="device_code" disabled></el-input>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no">
                <el-input v-model="model.channel_no"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'alertCancelLogEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                device_type: '',
                device_id: '',
                device_code: '',
                channel_no: '',
                remark: '',
                cancel_time: '',
                cancel_user_id: '',
                cancel_user_name: '',
            },
            getObj:{
                url:'/api/admin/alertcancellog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_type', 'device_cancel_type'],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/alertcancellog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>